"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doCpeDownload = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const api_1 = __importDefault(require("constants/api"));
const constants_1 = require("constants/constants");
const cpe_download_1 = require("types/api/request/cpe_download");
const doCpeDownload = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "cliente.cpe.download",
        token: loginDataJSON?.token,
        data: {
            //docentry: params?.data?.docentry,
            docs: params?.data?.docs,
            tipo: params?.data?.tipo,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => {
        response.headers.forEach((value, key) => { });
        return response?.blob();
    })
        .then((blob) => {
        let fileName;
        if (params?.data?.fileName) {
            fileName = params?.data?.fileName;
        }
        else if (Array.isArray(params?.data?.docs) &&
            (params?.data?.docs?.length ?? 0) > 1) {
            fileName =
                params?.data?.tipo == cpe_download_1.CpeDownloadType.FV
                    ? `facturas.zip`
                    : params?.data?.tipo == cpe_download_1.CpeDownloadType.GR
                        ? "GuiasRemision.zip"
                        : "NotasCredito.zip";
        }
        else if (Array.isArray(params?.data?.docs)) {
            fileName = `docs.pdf`;
        }
        else {
            fileName = `doc.pdf`;
        }
        callback?.onSuccess({
            blob,
            fileName: fileName,
        });
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doCpeDownload = doCpeDownload;
